module.exports = __webpack_public_path__ + "img/2.8dcc969c.png";